<template>
  <div>
    <el-card class="file-infos">
      <div slot="header"
           class="clearfix">
        <span>{{ $t('docMgt.fileInfo') }}</span>
      </div>
      <el-form ref="form" :model="fileInfo" label-width="100px">
        <el-form-item :label="$t('docMgt.name')">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.docNum')">
          <el-input :disabled="true" v-model="fileInfo.docCodes"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.vision')">
          <el-input :disabled="true" v-model="fileInfo.FileLastVerNumStr"></el-input>
        </el-form-item>
        <el-form-item :label="$t('instrData.status')">
          <el-input :disabled="true" v-model="fileInfo.IsDeleted"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密级">
          <el-select v-model="fileInfo.SecurityLevelId">
            <el-option v-for="(i, index) in secLevel" :key="index" :label="i.SecLevelName" :value="i.SecLevelId"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('docMgt.docSize')">
          <el-input :disabled="true" v-model="fileInfo.FileLastSizes"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.createTime')">
          <el-input :disabled="true" v-model="fileInfo.FileCreateTime"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.creatUser')">
          <el-input :disabled="true" v-model="fileInfo.FileCreateOperatorName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.modifyTime')">
          <el-input :disabled="true" v-model="fileInfo.FileModifyTime"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.modifyUser')">
          <el-input :disabled="true" v-model="fileInfo.FileModifyOperatorName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('docMgt.mark')">
          <el-input v-model="remark"></el-input>
        </el-form-item>
        <!-- <el-form-item label="标签">
          <div class="edit-tag">
            <el-tag type="info" v-for="(i, index) in tags" :key="index">{{i.TagName}}</el-tag>
            <i @click="showEditTag" class="el-icon-edit"></i>
          </div>
        </el-form-item> -->
      </el-form>
      <el-form>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('dataInput.save') }}</el-button>
          <el-button @click="cancle">{{ $t('dataInput.cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'fileInfo',
  props: ['modalInfo'],
  data() {
    return {
      fileInfo: null,
      tags: null,
      name: null,
      remark: null,
      secLevel: [
        {
          SecLevelDegree: 0,
          SecLevelId: 0,
          SecLevelName: '无密级'
        },
        {
          SecLevelDegree: 1,
          SecLevelId: 1,
          SecLevelName: '非密'
        },
        {
          SecLevelDegree: 2,
          SecLevelId: 2,
          SecLevelName: '内部'
        },
        {
          SecLevelDegree: 3,
          SecLevelId: 3,
          SecLevelName: '秘密'
        },
        {
          SecLevelDegree: 4,
          SecLevelId: 4,
          SecLevelName: '机密'
        }
      ]
    }
  },
  created() {
    this.fileInfo = this.modalInfo
    this.name = this.modalInfo.FileName
    this.remark = this.modalInfo.FileRemark
    if (this.fileInfo.IsDeleted) {
      this.fileInfo.IsDeleted = '已删除'
    } else {
      this.fileInfo.IsDeleted = '正常'
    }
    this.getFileTag()
  },
  methods: {
    getFileTag() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'GetFileTags')
      params.append('fileId', this.fileInfo.FileId)
      ApiService.oct_doc.common(params).then(res => {
        console.log(res)
        this.tags = res.tags
      })
    },
    showEditTag() {
      this.$store.commit('showModal', {
        name: 'edittags',
        show: true,
        top: '2.5rem',
        data: this.modalInfo
      })
    },
    cancle() {
      this.$store.commit('closeModal', 'fileInfo')
    },
    onSubmit() {
      let params = new FormData()
      params.append('module', 'WebClient')
      params.append('fun', 'ChangeFileName')
      params.append('newName', this.name)
      params.append('fileId', this.fileInfo.FileId)
      params.append('fileCode', this.fileInfo.FileCurCode)
      params.append('remark', this.remark)
      params.append('levelId', this.fileInfo.SecurityLevelId)
      ApiService.oct_doc.common(params).then(res => {
        if (res.result === 0) {
          this.fileUpdate()
        }
      })
    },
    // 本地更新文件名
    fileUpdate() {
      ApiService.doc.fileNameUpdate({
        FID: this.modalInfo.FileId,
        FileName: this.name + this.modalInfo.FileExtName
      }).then(res => {
        if (res.code == 0) {
          this.fileConcat(this.modalInfo.FileId, this.name + this.modalInfo.FileExtName)
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
          this.$store.commit('closeModal', 'rename')
        }
      })
    },
    fileConcat(fid, filename) {
      ApiService.doc.fileConcat({
        DID: 0,
        FID: fid,
        glid: '',
        BitNumber: '',
        FileName: filename,
        DocumentCode: this.modalInfo.docCode ? this.modalInfo.docCode: ''
      }).then(res => {
        if(res.code === 0) {
          this.handleSuccess()
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    handleSuccess() {
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.$store.commit('reloadFile', Math.random())
      this.$store.commit('closeModal', 'fileInfo')
    }
  }
}
</script>
<style lang="scss">
.file-infos {
  .el-card__body {
    width: 600px;
    height: 500px;
    overflow: auto;
    .el-select {
      display: block;
    }
    .edit-tag {
      display: flex;
      align-items: center;
      .el-tag {
        margin-right: 10px;
        float: left;
        border-radius: 13px;
      }
      i {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/fileInfo.vue